import { gql } from '@zenbusiness/application-commons-graphql';

export const GET_STATEMENTS_QUERY = gql`
  query StatementListItems($params: StatementListItemsInput!) {
    statementListItems(params: $params) {
      data {
        id
        month
        year
        account {
          id
          last4Digits
        }
      }
      pagination {
        offset
        limit
        next
      }
    }
  }
`;
